import {Card} from 'antd';
import Loading from 'components/shared-components/Loading';
import useDocPage from 'hooks/useDocPage';
import React from 'react';
import {useParams} from 'react-router-dom';

const DocumentationPage = () => {
  const params = useParams();
  const { page, isLoading } = useDocPage(params.id);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Card style={{ borderRadius: 20 }} className="w-100 docs-page-content">
      <div dangerouslySetInnerHTML={{ __html: page?.content }}></div>
    </Card>
  );
};

export default DocumentationPage;
